module.exports = __webpack_public_path__ + "img/ic_nat_appoint.4bea2113.png";